var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStatsCrown(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#FFD029"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5713 12H3.42916C3.31275 12 3.21146 11.913 3.18534 11.7902L2.0069 5.33992C1.9833 5.23339 2.02143 5.12258 2.10323 5.0579C2.18403 4.99322 2.29338 4.98721 2.38064 5.04544L5.60491 7.15661L7.80273 4.09866C7.89755 3.96711 8.10374 3.96711 8.19856 4.09866L10.396 7.15661L13.6194 5.04488C13.7056 4.98784 13.8151 4.99275 13.8968 5.05734C13.9786 5.12148 14.0167 5.23229 13.9931 5.33936L12.8152 11.7901C12.7885 11.9129 12.6877 12 12.5713 12Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsCrown);
export default __webpack_public_path__ + "static/media/stats-crown.5a77d635.svg";
export { ForwardRef as ReactComponent };